import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import VnrLink from "@components/VnrLink";
import { useRouter } from "next/router";
import React, { useEffect,useState } from "react";
import { isMobile } from "react-device-detect";
import Slider from "react-slick";
import useTranslate from 'src/hook/useTranslate';

import styles from "./SliderBroker.module.scss";

const SliderBroker = ({ brokers = [] }) => {
  const [loadFull, setLoadFull] = useState(!isMobile);
  const translate = useTranslate();
  const { locale } = useRouter();
  
  const renderRebate = (rebate) => {
    if (!rebate) {
      return null;
    }
    const indexLeftBracket = rebate.indexOf("(");
    const indexRightBracket = rebate.indexOf(")");
    let rebateRate = rebate;
    if (indexRightBracket !== -1) {
      rebateRate = rebate.slice(indexLeftBracket + 1, indexRightBracket);
    }
    if (rebateRate.startsWith("~")) {
      rebateRate = rebateRate.replace("~", "");
    }

    rebateRate = rebateRate.replace("Lên đến", "");
    return rebateRate;
  };


  useEffect(() => {
    let setTimeoutLoadFull;
    if (isMobile) {
      setTimeoutLoadFull = setTimeout(() => {
        setLoadFull(true);
      }, 10000);
    }
    return () => {
      if (setTimeoutLoadFull) {
        clearTimeout(setTimeoutLoadFull);
      }
    };
  }, [isMobile]);

  const Broker = ({ broker, slug, rebate }) => {
    const {link_register} = broker;
    const hrefMatch = link_register?.match(/href="([^"]*)"/) || '';
    let href = '';
    if (hrefMatch) {
      href = hrefMatch[1];
  }
    return (<VnrLink to={href} className={styles.brokerItem}>
        <div className={styles.logoBroker}>
          <a href={href} className="logoRebateBroker">
            <img
              src={
                broker.thumbnail
                  ? broker.thumbnail
                  : broker.avatar.sizes.thumbnail
              }
              alt={slug}
            />
          </a>
        </div>
        <div className={styles.title}>
          {translate.slickBroker.text} {renderRebate(rebate)}
        </div>
      </VnrLink>)
  };

  const settings = {
    dots: false,
    infinite: true,
    slidesToShow: isMobile 
      ? 2 
      : (locale === 'vi') 
        ? 6
        : 5
    ,
    slidesToScroll: 1,
    autoplay: true,
    cssEase: "linear",
    speed: 3200,
    autoplaySpeed: 3200,
    swipeToSlide: true,
    // lazyLoad: true,
  };
  return (
    <div className={styles.vnrSlickBroker}>
      <Slider {...settings}>
        {(brokers || []).map((broker, index) => {
          if (!broker.rebate || (!loadFull && isMobile && index > 3)) {
            return null;
          }
          return (
            <Broker
              key={broker.id}
              broker={broker.acf}
              slug={broker.slug}
              rebate={broker.rebate}
            />
          );
        })}
        {(brokers || []).map((broker, index) => {
          if (!broker.rebate || (!loadFull && isMobile && index > 3)) {
            return null;
          }
          return (
            <Broker
              key={broker.id}
              broker={broker.acf}
              slug={broker.slug}
              rebate={broker.rebate}
            />
          );
        })}
      </Slider>
    </div>
  );
};
export default SliderBroker;
